import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class KeysManagerFetchPartnerUsersPublicKeysError extends BaseEitherError {}

export type TKeysManagerFetchPartnerUsersPublicKeysOperationErrors =
  KeysManagerFetchPartnerUsersPublicKeysError;
